import { Page, TabbedLayout } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { useEffect } from 'react';
import { useTemplateCategories } from './use-templates-categories';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { ScaffolderPageForCategory } from './scaffolder-page-for-category';

const useStyles = makeStyles({
  scaffolderPageWrapper: {
    '& > article': {
      paddingInline: '0',
      paddingTop: '0',
    },
    '& > article > main': {
      overflowX: 'hidden',
      width: '100%',
      height: '100%',
    },
  },
});

export const TemplatesLandingPage = () => {
  const classes = useStyles();
  const catalogApi = useApi(catalogApiRef);
  const categories = useTemplateCategories(catalogApi);

  // positioning tabs under scaffolder page's header
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const page = document.querySelector('article > main');
      const tablist = document.querySelector("[role='tablist']");
      const tabs = tablist?.parentElement?.parentElement?.parentElement;
      const header = document.querySelector('header');

      if (!page || !tabs || !header || tabs.hasAttribute('positioned')) {
        return;
      }

      header.insertAdjacentElement('afterend', tabs);
      tabs.setAttribute('positioned', 'true');
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [categories]);

  return (
    <Page themeId="templates" className={classes.scaffolderPageWrapper}>
      <TabbedLayout>
        <TabbedLayout.Route path="/" title="all">
          <ScaffolderPageForCategory />
        </TabbedLayout.Route>
        {categories.map(category => (
          <TabbedLayout.Route
            path={`/${category}`}
            title={category}
            key={category}
          >
            <ScaffolderPageForCategory category={category} />
          </TabbedLayout.Route>
        ))}
      </TabbedLayout>
    </Page>
  );
};
